module.exports = __webpack_public_path__ + "img/jdb.58771b51.jpg";